import { useQuery } from 'react-query';
import { fetchTopRatedMovies } from '../services/api';

export const useTopRatedMovies = options => {
  return useQuery('topRatedMovies', fetchTopRatedMovies, options);
};
